import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Mission from "@/components/site/Mission";
import Industries from "@/components/site/Industries";
import Services from "@/components/site/Services";
import ConnectStrip from "@/components/site/ConnectStrip";
import ContactForm from "@/components/site/ContactForm";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import ConsentBanner from "@/components/ConsentBanner";
import { Seo } from "@/components/Seo";

const Index = () => {
  const businessJsonLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "AI Montclair",
    "description": "AI automation consulting for small businesses in Montclair, NJ. Specializing in chatbots, scheduling automation, and workflow optimization.",
    "url": "https://aimontclair.com",
    "email": "hello@aimontclair.com",
    "founder": {
      "@type": "Person",
      "name": "Andres Ravinet"
    },
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Montclair",
      "addressRegion": "NJ",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "40.8176",
      "longitude": "-74.2090"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Montclair"
      },
      {
        "@type": "AdministrativeArea",
        "name": "Essex County"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "AI Automation Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI Chatbot Development",
            "description": "Custom AI chatbots for customer service and lead generation"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Business Process Automation",
            "description": "Automated workflows to streamline business operations"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "AI-Powered Scheduling",
            "description": "Intelligent scheduling systems for appointments and resources"
          }
        }
      ]
    }
  };

  return (
    <>
      <Seo 
        title="AI Montclair - AI Automation for Small Businesses in Montclair, NJ"
        description="Transform your Montclair business with AI-powered automation. Chatbots, scheduling, workflow optimization. Free consultation available."
        canonical="/"
        ogType="website"
        image="https://aimontclair.com/lovable-uploads/a167bac5-9dad-43e5-b612-4fc85dc36158.png"
        jsonLd={businessJsonLd}
      />
      <main className="pb-24">
        <Navbar />
      <Hero />
      <Mission />
      <Industries />
      <Services />
      <ConnectStrip />
      <section id="contact" className="py-16 md:py-24">
        <div className="container mx-auto max-w-2xl">
          <header className="mb-8 text-center">
            <h2 className="text-4xl md:text-5xl font-semibold">Contact</h2>
            <p className="text-lg md:text-xl text-muted-foreground mt-2">
              Have a question or want to work together? Send us a message.
            </p>
          </header>
          <ContactForm />
        </div>
      </section>
      <FAQ />
        <Footer />
        <ConsentBanner />
      </main>
    </>
  );
};

export default Index;
